import { OnlineStatus } from './OnlineStatus';

/**
 * Footer panel displaying connection states and version numbers.
 */
export function Footer() {
  return (
    <footer className="w-full flex items-center justify-between px-6 py-4 border-t border-white/5 bg-slate-950/20 z-30">
      {/* Connected signal status */}
      <div className="flex items-center space-x-2">
        <OnlineStatus />
        <span className="text-[10px] font-bold tracking-widest text-surface-500 uppercase hidden sm:inline-block">
          |
        </span>
        <div className="hidden sm:flex items-center space-x-1.5">
          <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
          <span className="text-[10px] font-bold tracking-wider text-surface-400 uppercase">
            Connected
          </span>
        </div>
      </div>

      {/* Version */}
      <div>
        <p className="text-[10px] font-bold tracking-widest font-mono text-surface-400 uppercase">
          Version v1.0.0
        </p>
      </div>
    </footer>
  );
}
